import React from 'react';
import sAction from 'sAction';

import CustomLinesHeader_orig from 'ROOT/src/components/detailView/CustomLines/CustomLinesHeader';


export default class CustomLinesHeader extends CustomLinesHeader_orig {
    constructor(props) {
        super(props);

        this.state = {cols: []};
    }

    getField(col, key) {
        const moduleData = this.props.moduleData;
        const info = this.props.info;
        console.log(col);
        const required = moduleData.get && moduleData.get(col).get && moduleData.get(col).get('required') ? (<span className='required'>*</span>) : null;
        let style = null;
        const def = this.props.def;
        if (def.get && def.get('style') && def.get('style').get && def.get('style').get(col)) {
            style = def.get('style').get(col).toJS();
        }

        return (
            <div title={sAction.translate(moduleData.get(col).get('vname'), info.get('module'))} className='customLinesCell' key={key} style={style}>{sAction.translate(moduleData.get(col).get('vname'), info.get('module'))}</div>
        );
    }

    getLineButtons() {
        /* var minWidth = 0;
        if (sAction.hasAccess(this.props.info.get('module'), "detail")) {
            if (this.props.info.get('eyeIcon')) {
                minWidth += 14;
            }
            if (this.props.info.get('detailButton')) {
                minWidth += 14;
            }
        }
        if (sAction.hasAccess(this.props.info.get('module'), "edit")) {
            if (this.props.info.get('orderRow') && this.props.info.get('ordering') === 'manual') {
                minWidth += 14;
            }
            minWidth += 16;
        }

        return (
            <div className='customLinesCell customLinesCellDelete' key={'buttons'} style={{minWidth: minWidth + 'px',}}>
            </div>
        );*/

        return '';
    }

    render() {
        const def = this.props.def;

        const cols = [];
        def.get('fields').toJS().forEachObject((col, key) => {
            cols.push(this.getField(col, key));
        });
        const lineButtons = this.getLineButtons();

        return (
            <div className='customLinesRowContainer customLinesHeader'>
                {lineButtons}
                {cols}
            </div>
        );
    }
}
